import { REGEX_CONSTANT } from "../../../constant/regexConstant";

export const validOrder = (namespace, data, translate) => {
  let error = {};

  switch (namespace) {
    case "company_profile_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      }
      // else if(data.length > 256){
      //   error[namespace] = translate("COMMON:MAX_LENGTH", {
      //     field: translate("CUSTOMER:ADDITIONAL_NAME"),
      //   });
      // }
       else {
        error[namespace] = null;
      }
      break;
      case "recipient_name":
        if (!data) {
          error[namespace] = translate("COMMON:REQUIRE", {
            field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
          });
        } else{
          error[namespace] = null;
        }
        break;
      case "recipient_phone":
        if (!data) {
          error[namespace] = translate("COMMON:REQUIRE", {
            field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
          });
        }else if (data.length > 12 || data.length < 10) {
          error[namespace] = translate("min 10 character, max 12 character", {
            field: translate("CUSTOMER:EMAIL"),
          });
        } else if(!REGEX_CONSTANT.PHONE_NUMBER.test(data)){
          error[namespace] = translate("Invalid Format", {
            field: translate("Role ID"),
          });
        } else{
          error[namespace] = null;
        }
        break;
      case "first_name":
        if (!data) {
          error[namespace] = translate("COMMON:REQUIRE", {
            field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
          });
        }else if(data.length > 50){
          error[namespace] = translate("COMMON:MAX_LENGTH", {
            field: translate("CUSTOMER:ADDITIONAL_NAME"),
          });
        } else {
          error[namespace] = null;
        }
        break;
        // case "delivery_type_id":
        // if (!data) {
        //   error[namespace] = translate("COMMON:REQUIRE", {
        //     field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
        //   });
        // } 
        // else {
        //   error[namespace] = null;
        // }
        // break;
        case "temperature_category":
          if (!data) {
            error[namespace] = translate("COMMON:REQUIRE", {
              field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
            });
          } else {
            error[namespace] = null;
          }
          break;
          case "total_price":
            if (!data) {
              error[namespace] = translate("COMMON:REQUIRE", {
                field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
              });
            } else {
              error[namespace] = null;
            }
            break;
            case "order_priority":
            if (!data) {
              error[namespace] = translate("COMMON:REQUIRE", {
                field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
              });
            } else {
              error[namespace] = null;
            }
            break;
            case "delivery_notes":
              if (data.length>256) {
                error[namespace] = translate("Max length 256", {
                  field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
                });
              } else {
                error[namespace] = null;
              }
              break;
              case "skill_set":
            if (!data) {
              error[namespace] = translate("COMMON:REQUIRE", {
                field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
              });
            } else {
              error[namespace] = null;
            }
            break;
            case "item_brand":
            if (!data) {
              error[namespace] = translate("COMMON:REQUIRE", {
                field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
              });
            }else if(data.length>256) {
              error[namespace] = translate("Max length 256", {
                field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
              });
            } else {
              error[namespace] = null;
            }
            break;
            // case "product_id":
            //   if (!data) {
            //     error[namespace] = translate("COMMON:REQUIRE", {
            //       field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
            //     });
            //   } else {
            //     error[namespace] = null;
            //   }
            //   break;
            case "item_name":
            if (!data) {
              error[namespace] = translate("COMMON:REQUIRE", {
                field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
              });
            } else {
              error[namespace] = null;
            }
            break;
            case "item_category":
            if (!data) {
              error[namespace] = translate("COMMON:REQUIRE", {
                field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
              });
            }else if(data.length>256) {
              error[namespace] = translate("Max length 256", {
                field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
              });
            }  else {
              error[namespace] = null;
            }
            break;
            case "no_of_item":
            if (!data) {
              error[namespace] = translate("COMMON:REQUIRE", {
                field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
              });
            }else if (!REGEX_CONSTANT.INTEGER.test(data)) {
              error[namespace] = translate("Invalid Format", {
                field: translate("Role ID"),
              });
            } else {
              error[namespace] = null;
            }
            break;
            case "no_of_item_per_pallet":
            if (!data) {
              error[namespace] = translate("COMMON:REQUIRE", {
                field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
              });
            }else if (!REGEX_CONSTANT.INTEGER.test(data)) {
              error[namespace] = translate("Invalid Format", {
                field: translate("Role ID"),
              });
            } else {
              error[namespace] = null;
            }
            break;
            case "pallet_id":
            if (!data) {
              error[namespace] = translate("COMMON:REQUIRE", {
                field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
              });
            } else {
              error[namespace] = null;
            }
            break;
            case "customer_id":
            if (!data) {
              error[namespace] = translate("COMMON:REQUIRE", {
                field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
              });
            } else {
              error[namespace] = null;
            }
            break;
            case "weight":
            if (!data) {
              error[namespace] = translate("COMMON:REQUIRE", {
                field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
              });
            }else if (!REGEX_CONSTANT.FLOAT.test(data)) {
              error[namespace] = translate("Invalid Format", {
                field: translate("Role ID"),
              });
            } else {
              error[namespace] = null;
            }
            break;
            case "width":
            if (!data) {
              error[namespace] = translate("COMMON:REQUIRE", {
                field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
              });
            }else if (!REGEX_CONSTANT.FLOAT.test(data)) {
              error[namespace] = translate("Invalid Format", {
                field: translate("Role ID"),
              });
            } else {
              error[namespace] = null;
            }
            break;
            case "height":
            if (!data) {
              error[namespace] = translate("COMMON:REQUIRE", {
                field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
              });
            }else if (!REGEX_CONSTANT.FLOAT.test(data)) {
              error[namespace] = translate("Invalid Format", {
                field: translate("Role ID"),
              });
            } else {
              error[namespace] = null;
            }
            break;
            case "length":
            if (!data) {
              error[namespace] = translate("COMMON:REQUIRE", {
                field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
              });
            }else if (!REGEX_CONSTANT.FLOAT.test(data)) {
              error[namespace] = translate("Invalid Format", {
                field: translate("Role ID"),
              });
            } else {
              error[namespace] = null;
            }
            break;
            case "volume":
            if (!data) {
              error[namespace] = translate("COMMON:REQUIRE", {
                field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
              });
            }else if (!REGEX_CONSTANT.FLOAT.test(data)) {
              error[namespace] = translate("Invalid Format", {
                field: translate("Role ID"),
              });
            } else {
              error[namespace] = null;
            }
            break;
            case "subtotal_case_weight":
            if (!REGEX_CONSTANT.FLOAT.test(data)) {
              error[namespace] = translate("Invalid Format", {
                field: translate("Role ID"),
              });
            } else {
              error[namespace] = null;
            }
            break;
    default:
      break;
  }
  return error;
};
